import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import Wrapper from '../Containers/Wrapper';
import WrapperConsumer from '../store';
import { retrieveCredentials } from '../helpers/storage';

const PrivateRoute = (props) => {
  const { context: { language }, location: { pathname } } = props;
  const { idmpleado } = retrieveCredentials();

  if (!idmpleado) return <Redirect to={{ pathname: '/login' }} />;
  if (!language && pathname === '') return <Redirect to={{ pathname: '/error' }} />;

  window.scrollTo(0, 0);

  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return (
          <Wrapper >
            <Component {...routeProps} />
          </Wrapper>
        )
      }}
    />
  );
};

export default WrapperConsumer(PrivateRoute);